module.exports = __webpack_public_path__ + "static/media/icons-split-screen.96110da8.svg";